/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_RunsInputs */

const en_mk_mx_runs = /** @type {(inputs: Mk_Mx_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent tasks per month`)
};

const id_mk_mx_runs = /** @type {(inputs: Mk_Mx_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tugas agen per bulan`)
};

/**
* | output |
* | --- |
* | "Agent tasks per month" |
*
* @param {Mk_Mx_RunsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_runs = /** @type {((inputs?: Mk_Mx_RunsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_RunsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_runs(inputs)
	return en_mk_mx_runs(inputs)
});